import { useState } from 'react';

interface NavigationProps {
  activeSection: string;
  scrollToSection: (sectionId: string) => void;
}

export default function Navigation({ activeSection, scrollToSection }: NavigationProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { id: 'hero', label: 'TOP' },
    { id: 'schedule', label: 'SCHEDULE' },
    { id: 'ticket', label: 'TICKET' },
    { id: 'goods', label: 'GOODS' },
    { id: 'information', label: 'INFO' }
  ];

  const handleMenuClick = (sectionId: string) => {
    scrollToSection(sectionId);
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Desktop Navigation - Fixed */}
      <nav className="hidden md:block fixed top-0 left-0 right-0 z-30 bg-[#1a1a2e]/95 backdrop-blur-sm">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center">
              <span className="text-xs md:text-sm font-bold">
                <span className="text-[#44c4ff]">IRINO MIYU</span>
                {' '}
                <span className="text-[#1ef99d]">LIVE TOUR</span>
                {' '}
                <span className="text-[#fc457e]">2026</span>
              </span>
            </div>
            
            <div className="flex gap-2 md:gap-4">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`px-3 py-2 text-xs transition-all duration-300 border-2 whitespace-nowrap cursor-pointer ${
                    activeSection === item.id
                      ? 'bg-[#44c4ff] text-[#0a0a0a] border-[#44c4ff] shadow-[0_0_10px_#44c4ff]'
                      : 'bg-[#16213e] text-[#44c4ff] border-[#44c4ff] hover:bg-[#44c4ff] hover:text-[#0a0a0a]'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        </div>
        
        {/* Multi-color border */}
        <div className="h-1 flex">
          <div className="flex-1 bg-[#44c4ff]"></div>
          <div className="flex-1 bg-[#ad12f2]"></div>
          <div className="flex-1 bg-[#fcb122]"></div>
          <div className="flex-1 bg-[#ad12f2]"></div>
          <div className="flex-1 bg-[#fcb122]"></div>
          <div className="flex-1 bg-[#fc457e]"></div>
          <div className="flex-1 bg-[#fcb122]"></div>
        </div>
      </nav>

      {/* Mobile Menu Button - Fixed */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="md:hidden fixed top-4 right-4 z-30 w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer bg-[#1a1a2e]/95 backdrop-blur-sm border-2 border-white"
        aria-label="メニュー"
      >
        <span className={`w-6 h-0.5 bg-[#44c4ff] transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
        <span className={`w-6 h-0.5 bg-[#1ef99d] transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
        <span className={`w-6 h-0.5 bg-[#fc457e] transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
      </button>

      {/* Mobile Menu Dropdown - Fixed */}
      <div className={`md:hidden fixed top-16 right-4 z-30 overflow-hidden transition-all duration-300 ${isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="bg-[#16213e]/95 backdrop-blur-sm border-2 border-[#44c4ff] rounded shadow-[0_0_20px_rgba(68,196,255,0.5)]">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleMenuClick(item.id)}
              className={`w-full px-4 py-3 text-xs text-left transition-all duration-300 border-b border-[#1a1a2e] last:border-b-0 whitespace-nowrap cursor-pointer ${
                activeSection === item.id
                  ? 'bg-[#44c4ff] text-[#0a0a0a] shadow-[inset_0_0_10px_rgba(68,196,255,0.5)]'
                  : 'text-[#44c4ff] hover:bg-[#1a1a3e]'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}